import { ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Lecture } from '../shared/lecture';
import { APPCONFIG } from "../../config";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-lecture-nav-list',
  templateUrl: './lecture-nav-list.component.html'
})
export class LectureNavListComponent implements OnInit{
  @Input() filter: string;
  @Input() lectures: Observable<Lecture[]>;
  AppConfig: any;

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-nav-list/lecture-nav-list.component.ts